document.addEventListener('DOMContentLoaded', function () {
    const loadMoreButton = document.querySelector('.infinite_next a');

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function (e) {
            e.preventDefault();
            loadNextPage(this.href);
        });
    }

    function loadNextPage(url) {
        fetch(url)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newItems = doc.querySelectorAll('#product-grid .grid__item');
                const productGrid = document.querySelector('#product-grid');

                newItems.forEach(item => {
                    productGrid.appendChild(item);
                });

                // Update the next page URL if available
                const newNextButton = doc.querySelector('.infinite_next a');
                if (newNextButton) {
                    loadMoreButton.href = newNextButton.href;
                } else {
                    loadMoreButton.style.display = 'none'; // Hide button if no more pages
                }
            })
            .catch(error => console.error('Error loading next page:', error));
    }
});
